export const recordFields = [
  { label: 'Номер отправленный в БЦК', key: 'returnId' },
  { label: 'Причина возврата', key: 'returnNote' },
  { label: 'Общая сумма', key: 'amount' },
  { label: 'Сумма возврата', key: 'returnAmount' },
  { label: 'Дата создания', key: 'createDate' },
  { label: 'Статус', key: 'status' },
];
export const doneRecordFields = [
  { label: 'Номер отправленный в БЦК', key: 'returnId' },
  { label: 'Причина возврата', key: 'returnNote' },
  { label: 'Общая сумма', key: 'amount' },
  { label: 'Сумма возврата', key: 'returnAmount' },
  { label: 'Дата создания', key: 'createDate' },
  { label: 'Дата отработки', key: 'processed_date' },
  { label: 'Статус', key: 'status' },
  { label: 'Комментарий', key: 'comment' },
];

export const returnRecordFields = [
  { label: 'Номер отправленный в БЦК', key: 'returnId' },
  { label: 'Причина возврата', key: 'returnNote' },
  { label: 'Общая сумма', key: 'amount' },
  { label: 'Сумма возврата', key: 'returnAmount' },
  { label: 'Дата', key: 'returnDate' },
  { label: 'Статус', key: 'status' },
  { label: 'Сообщение', key: 'comment' },
];

export const returnWorkedOutFields = [
  { label: 'Номер отправленный в БЦК', key: 'returnId' },
  { label: 'Причина возврата', key: 'returnNote' },
  { label: 'Общая сумма', key: 'amount' },
  { label: 'Сумма возврата', key: 'returnAmount' },
  { label: 'Дата', key: 'returnDate' },
  { label: 'Статус', key: 'status' },
  { label: 'Банк счёт', key: 'bank_acc' },
  { label: 'Сообщение', key: 'comment' },
];

export const returnReplyTableNextDrawer = [
  { label: 'Номер отправленный в БЦК', key: 'returnId' },
  { label: 'Причина возврата', key: 'returnNote' },
  { label: 'Общая сумма', key: 'amount' },
  { label: 'Сумма возврата', key: 'returnAmount' },
  { label: 'Дата', key: 'returnDate' },
  { label: 'Статус', key: 'status' },
  { label: 'Дата переотправки', key: 'send_date' },
];

export const statusText = {
  done: 'Переотправлен в БЦК',
  refund_client: 'Возвращен клиенту',
  new: 'Нерешенный',
  income: 'Отработан',
};
